import { Button, Typography, useTheme } from "@mui/material";
import { useMemo } from "react";
import LinkIcon from "@mui/icons-material/Link";
import CheckIcon from "@mui/icons-material/Check";
import { ShareConfigCodeRoot } from "./ShareConfigCode.styles";
import ShareIcon from "@mui/icons-material/Share";
import { useClipboard } from "../../hooks/useClipboard";
import { useSelectedOptions } from "../../context/SelectedOptionsContext";

export const ShareConfigCode = () => {
  const theme = useTheme();
  const { currentTranslations } = useSelectedOptions();
  const { handleCopy, copyStatus } = useClipboard();
  // 1. Get the current URL from the browser's window object.
  const urlToCopy = useMemo(() => {
    // Check if running in a browser environment
    if (typeof window !== "undefined") {
      return window.location.href;
    }
    return ""; // Return empty string on server side
  }, []);

  const handleClick = () => {
    handleCopy(urlToCopy);
  };

  /**
   * Tries to use the Web Share API to open the native sharing dialog.
   */
  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: currentTranslations?.contactPopUp?.share?.widget?.title,
          text: currentTranslations?.contactPopUp?.share?.widget?.text,
          url: urlToCopy,
        });
        // console.log("Content shared successfully");
      } catch (error) {
        console.error("Error sharing:", error);
      }
    } else {
      // Fallback if Web Share API is not supported (e.g., desktop browser)
      console.warn("Web Share API not supported on this device/browser.");
      // For desktop, usually clicking "Copy configuration link" is the expectation,
      // or you would implement a custom modal with social links here.
    }
  };

  const buttonText =
    copyStatus === "success"
      ? currentTranslations?.contactPopUp?.share?.buttonLinkSuccess
      : currentTranslations?.contactPopUp?.share?.buttonLink;
  const buttonIcon = copyStatus === "success" ? <CheckIcon /> : <LinkIcon />;

  return (
    <ShareConfigCodeRoot>
      <Button
        startIcon={buttonIcon}
        onClick={handleClick}
        sx={{
          minWidth: "285px",
          height: "45px",
          color: `${theme?.palette?.companyColors?.secondary} !important`,
          opacity: copyStatus === "success" ? 0.5 : 1,
          background: theme?.palette?.companyColors?.accent,
          borderRadius: theme?.borderRadius?.small,
          transition: "all ease-in-out 0.5s",
          padding: { xs: "0.75rem 2rem", xl: "0.75rem 1.5rem" },
          "@media (orientation: portrait)": {
            width: "100%",
          },
        }}
        disabled={copyStatus === "success"} // Optional: Disable button when success message is shown
      >
        <Typography
          variant="button"
          sx={{
            textTransform: "initial",
            fontSize: { xs: "1.85rem", lg: "1.5rem" },
            fontWeight: 400,
          }}
        >
          {buttonText}
        </Typography>
      </Button>
      <Button
        startIcon={<ShareIcon />}
        sx={{
          minWidth: "285px",
          height: "45px",
          color: theme?.palette?.companyColors?.secondary,
          background: theme?.palette?.companyColors?.accent,
          borderRadius: theme?.borderRadius?.small,
          padding: { xs: "0.75rem 2rem", xl: "0.75rem 1.5rem" },
          "@media (orientation: portrait)": {
            width: "100%",
          },
        }}
        onClick={handleShare}
      >
        <Typography
          variant="button"
          sx={{
            textTransform: "initial",
            fontSize: { xs: "1.85rem", lg: "1.5rem" },
            fontWeight: 400,
          }}
        >
          {currentTranslations?.contactPopUp?.share?.buttonShare}
        </Typography>
      </Button>
    </ShareConfigCodeRoot>
  );
};
